export function GapList({ title, items, tone }: { title: string; items: string[]; tone: string }) {
  return (
    <div>
      <h4 className={`mb-1 text-xs font-semibold uppercase tracking-wide ${tone}`}>{title}</h4>
      {items.length === 0 ? (
        <p className="text-xs vscode-text-tertiary">None</p>
      ) : (
        <ul className="list-inside list-disc text-xs vscode-text-secondary">
          {items.slice(0, 8).map((s, i) => (
            <li key={`${i}-${s}`}>{s}</li>
          ))}
          {items.length > 8 ? <li className="list-none vscode-text-tertiary">+{items.length - 8} more</li> : null}
        </ul>
      )}
    </div>
  );
}
